import { Modal } from "react-bootstrap-v5";

const CommonModal = ({
  open,
  onClose,
  children,
  size = "lg",
  fullWidth = true,
  dialogClass = "",
  ...rest
}) => {
  return (
    <Modal
      show={open}
      // onHide={onClose}
      centered
      dialogClassName={dialogClass}
      {...rest}
      size={size}
    >
      <div>{children}</div>
    </Modal>
  );
};

export default CommonModal;
